import { AuthThirdPartyProviders, createIamClient } from '@applica-software-guru/persona-iam-sdk/core'
import { config } from '@/lib/config'

export { AuthThirdPartyProviders }

export const iamClient = createIamClient({
  apiUrl: config.iamUrl,
})
